<template>
	<div class="ml-600-lg display-flex overflow-scroll">
		<PortfolioPerformanceReturnJumboChip
			v-for="(returnData, index) in props.data"
			:key="index"
			:return-data="returnData"
			:selected-chip="props.selectedChip"
			:show-return-indicator="props.showReturnIndicator"
			class="mr-100"
			@return-chip-selected="handleReturnJumboChipSelect"
		/>
	</div>
</template>

<script setup lang="ts">
import { PerformanceReturnJumboChip, PerformanceReturnJumboChipEnum } from 'types/performance-portfolio';
import PortfolioPerformanceReturnJumboChip from '@components/account/portfolio/portfolio-performance-return-jumbo-chip.vue';

interface Props {
	data: Array<PerformanceReturnJumboChip>;
	selectedChip: PerformanceReturnJumboChipEnum;
	showReturnIndicator?: boolean;
}

interface Emits {
	(e: 'return-chip-selected', value: PerformanceReturnJumboChipEnum): void;
}

const props = withDefaults(defineProps<Props>(), {
	showReturnIndicator: true
});

const emits = defineEmits<Emits>();

function handleReturnJumboChipSelect(chip: PerformanceReturnJumboChipEnum): void {
	emits('return-chip-selected', chip);
}

function setup(): void {
	handleReturnJumboChipSelect('NET_RETURN');
}

setup();
</script>

<style lang="scss" scoped>
@use '../../../styles/utilities/respond-to.scss' as *;
.performance-return-jumbo-chips-wrapper {
	@include respond-to(md) {
		margin-top: -60px;
	}
}
</style>
